import { render, staticRenderFns } from "./SideBarNew.vue?vue&type=template&id=32a28348&scoped=true&"
import script from "./SideBarNew.vue?vue&type=script&lang=js&"
export * from "./SideBarNew.vue?vue&type=script&lang=js&"
import style0 from "./SideBarNew.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SideBarNew.vue?vue&type=style&index=1&id=32a28348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a28348",
  null
  
)

export default component.exports